<button [disabled]="disabled">{{ label | translate }}</button>
